import React, { useState } from 'react';

const TrustedClients = () => {
  const clients = [
    { 
      name: 'McCarthy Building Companies', 
      shortName: 'McCarthy',
      url: 'https://www.mccarthy.com/',
      color: '#003366'
    },
    { 
      name: 'Kawasaki Motors', 
      shortName: 'Kawasaki',
      url: 'https://www.kawasaki.com/en-us/',
      color: '#6ABF4B'
    },
    { 
      name: 'Vortex Doors', 
      shortName: 'Vortex',
      url: 'https://www.vortexdoors.com/',
      color: '#1E3A5F'
    },
    { 
      name: 'OC Air', 
      shortName: 'OC Air',
      url: 'https://www.ocair.com/',
      color: '#0066CC'
    },
    { 
      name: 'City of Irvine', 
      shortName: 'Irvine',
      subtitle: 'City of',
      url: 'https://cityofirvine.org/',
      color: '#2B5F2B'
    },
    { 
      name: 'City of Santa Ana', 
      shortName: 'Santa Ana',
      subtitle: 'City of',
      url: 'https://www.santa-ana.org/',
      color: '#8B0000'
    },
    { 
      name: 'UC Irvine', 
      shortName: 'UCI',
      subtitle: 'University',
      url: 'https://uci.edu/',
      color: '#0064A4'
    },
  ];

  return (
    <section className="relative py-20 bg-ivory-50" data-testid="trusted-clients-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold text-ivory-800 mb-4">
            Trusted by Happy Customers
          </h2>
          <p className="text-ivory-500 text-lg max-w-2xl mx-auto font-body">
            Proudly serving leading corporations, municipalities, and institutions
          </p>
        </div>
        
        {/* Logo Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4 lg:gap-5 max-w-6xl mx-auto items-center justify-items-center">
          {clients.map((client, index) => (
            <ClientCard key={client.name} client={client} index={index} />
          ))}
        </div>
        
        {/* Elegant gold divider */}
        <div className="divider-gold mt-16 max-w-xl mx-auto" />
      </div>
    </section>
  );
};

const ClientCard = ({ client, index }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <a
      href={client.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative w-full h-24 flex items-center justify-center p-4 rounded-xl bg-ivory-100 border border-ivory-200 hover:border-gold-500/40 hover:bg-white transition-all duration-500 hover:shadow-luxury-lg overflow-hidden"
      style={{ 
        animationDelay: `${index * 80}ms`,
      }}
      data-testid={`client-logo-${index}`}
      title={client.name}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Subtle background accent on hover */}
      <div 
        className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500"
        style={{ backgroundColor: client.color }}
      />
      
      <div className="relative flex flex-col items-center justify-center text-center z-10">
        {client.subtitle && (
          <span className="text-[10px] sm:text-xs text-ivory-400 group-hover:text-gold-500 transition-colors duration-300 font-body uppercase tracking-wider mb-0.5">
            {client.subtitle}
          </span>
        )}
        <span 
          className="text-sm sm:text-base font-semibold transition-colors duration-300 font-heading tracking-tight"
          style={{ 
            color: isHovered ? client.color : 'hsl(30, 12%, 30%)'
          }}
        >
          {client.shortName}
        </span>
      </div>
    </a>
  );
};

export default TrustedClients;
